'use client'
import { memo } from 'react'
import { mq, presets, vw } from '@/styles'
import styled from 'styled-components'
import { TypeCmsVectorImage } from '@/schema'
import NextImage from 'next/image'

type Props = {
  data: {
    description: string
    logo?: TypeCmsVectorImage | string | null
    name: string
  }
}

export const ContentSectionBrand = memo(({ data }: Props) => {
  const logoSrc = typeof data.logo === 'string' ? data.logo : data.logo?.src
  const logoAlt = typeof data.logo === 'string' ? data.name : data.logo?.alt || data.name

  return (
    <Article {...!logoSrc ? { className: 'no-logo' } : {}}>
      <h2>{data.name}</h2>
      {logoSrc && <NextImage src={logoSrc} alt={logoAlt} unoptimized width={200} height={200}/>}
			{data.description && (
        <div className='text-wrapper'>
          <div dangerouslySetInnerHTML={{ __html: data.description }} />
        </div>
      )}
    </Article>
  )
})

const Article = styled.article`
  align-items: center;
  display: none;
  flex-direction: column;
  grid-column: 1 / span 6;
  grid-row: 1 / span 1;
  margin: 10px 0 60px;

  ${mq.greaterThan('tablet')} {
		display: flex;
    grid-column: 1 / span 12;
  }

  ${mq.greaterThan('container')} {
    max-width: var(--page-container-max-width);
  }

	&.no-logo {
		h2 {
			margin-bottom: 0;
		}
	}

  img {
    flex-shrink: 0;
    margin-bottom: ${vw(20, 'mobile')};
    user-select: none;
    width: ${vw(125, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      margin-bottom: ${vw(20, 'tablet')};
      width: ${vw(125, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      margin-bottom: 0;
      width: ${vw(165, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      width: 165px;
    }
  }

  .text-wrapper {
    ${presets.font18_1}
    color: var(--color-text--darker);
    padding-top: ${vw(48, 'mobile')};
    width: 95%;

    ${mq.greaterThan('nexus7')} {
      padding-top: ${vw(48, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      width: 50%;
      padding-top: ${vw(60, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      padding-top: 60px;
    }
  }

  h2 {
    ${presets.font20_5}
    color:  var(--color-text);
    letter-spacing: -0.5;
    margin-bottom: ${vw(46, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      margin-bottom: ${vw(46, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      margin-bottom: ${vw(60, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-bottom: 60px;
    }
  }

  h2,
  p,
  a {
    ${mq.greaterThan('tablet')} {
      text-align: left;
    }
  }
`
